import type { IconNames } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { v4 as uuid } from 'uuid';

import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import {
  FlowNode,
  flowNodeColor,
  InternalPortT,
  NodeT,
  NodeTypeComponent,
  RegisterPortT,
} from 'fable/flowEditor';

import { PowerCallFlowExtraDataT } from '../PowerCallFlow';
import AnnounceFromPayload from '../helpers/announceFromPayload';
import { RecordConversation as ActionModal } from '../modals/recordConversation';
import type { AnnouncementPayloadT } from '../types';

type Payload = {
  announcement: null | AnnouncementPayloadT;
  nextNode: null | string;
};

export type FlowCallNodeRecordConversation = NodeT<
  FlowNodeTypes.RECORD_CONVERSATION,
  Payload
>;

const portTranslator = (
  node: FlowCallNodeRecordConversation,
): RegisterPortT[] => [
  {
    id: uuid(),
    type: 'out',
    label: 'arrow',
    connection: node.payload.nextNode || uuid(),
  },
];

export class RecordConversationNode extends NodeTypeComponent<
  FlowCallNodeRecordConversation,
  PowerCallFlowExtraDataT
>() {
  static icon: IconNames = 'rec';
  static label = 'Record conversation';
  static helpText =
    'All conversations after this action in the flow will be recorded. The recording will be stored under Conversations.';
  static color = flowNodeColor.blue;
  static translatePayload = formatPortsHelper(portTranslator);
  static ActionModal = ActionModal;
  static actionTrigger = { type: FlowNodeTypes.RECORD_CONVERSATION };
  static updateConnection = (
    node: FlowCallNodeRecordConversation,
    _port: InternalPortT,
    newConnection: string,
  ): FlowCallNodeRecordConversation => {
    const payload = { ...node.payload };
    payload.nextNode = newConnection;

    return { ...node, payload };
  };

  @boundMethod
  triggerEdit(): void {
    const { onEdit, node } = this.props;
    onEdit(node, node.nodeType);
  }

  render() {
    return (
      <FlowNode
        color={RecordConversationNode.color}
        icon={RecordConversationNode.icon}
        label={RecordConversationNode.label}
        text={
          <AnnounceFromPayload
            node={this.props.node}
            extraData={this.props.extraData}
          />
        }
        onEdit={this.triggerEdit}
      />
    );
  }
}
